import { render, staticRenderFns } from "./DesignList.vue?vue&type=template&id=e6d56558&scoped=true"
import script from "./DesignList.vue?vue&type=script&lang=js"
export * from "./DesignList.vue?vue&type=script&lang=js"
import style0 from "./DesignList.vue?vue&type=style&index=0&id=e6d56558&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6d56558",
  null
  
)

export default component.exports